import { Box, CircularProgress, styled, Typography } from '@mui/material';
import { EColors, getColor } from 'theme';

const Content = styled(Box)(({ theme: { spacing } }) => ({
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingLeft: spacing(1),
    cursor: 'pointer',
}));

const Description = styled(Typography)({
    lineHeight: '100%',
    fontWeight: 700,
    color: getColor(EColors.v3Dark, 0.6),
    '& > span': {
        color: getColor(EColors.v3Dark),
        fontSize: '0.875rem',
        fontStyle: 'normal',
        fontWeight: 700,
        textDecorationLine: 'underline',
    },
    fontFamily: '"Switzer", Roboto, Inter, -apple-system, BlinkMacSystemFont, sans-serif',
});

type UploadContentProps = {
    isDragActive: boolean;
    isUploading?: boolean;
    uploadSuffix?: string;
    maxSizeMb?: number;
};

export function UploadContent({ isDragActive, isUploading, uploadSuffix, maxSizeMb = 4 }: UploadContentProps) {
    if (isDragActive) {
        return (
            <Box width="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                <Typography variant="body2">Drop the files here</Typography>
            </Box>
        );
    }

    if (isUploading) {
        return (
            <Box width="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                <CircularProgress size={24} sx={{ color: getColor(EColors.pureBlack) }} />
            </Box>
        );
    }

    return (
        <Content>
            <Description>
                <span>Upload</span> or <span>drag and drop</span>
                {uploadSuffix && ` ${uploadSuffix}`}
            </Description>
            <Typography fontSize="0.75rem" fontWeight={500} color={getColor(EColors.v3TextSecondary)}>
                format should be jpg or png, max {maxSizeMb} MB
            </Typography>
        </Content>
    );
}
